webpackJsonp([176236309070072],{

/***/ 112:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/team-header-big.b6694a01.jpg";

/***/ }),

/***/ 113:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/team-header-small.9b11f08e.jpg";

/***/ }),

/***/ 37:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.TeamCard = exports.TeamDescription = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEmotion = __webpack_require__(6);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _colors = __webpack_require__(3);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cardStyle = /*#__PURE__*/(0, _reactEmotion.css)('margin:1em auto;padding:1rem 1.5rem;& h2{color:inherit;margin:1.25rem 0;}');
	
	var cardNormal = /*#__PURE__*/(0, _reactEmotion.css)(cardStyle, ';background-color:white;');
	
	var cardInverted = /*#__PURE__*/(0, _reactEmotion.css)(cardStyle, ';background-color:', _colors2.default.black, ';');
	
	var teamStyle = /*#__PURE__*/(0, _reactEmotion.css)(cardStyle, ';padding:0;margin:0;margin-top:2rem;background-color:', _colors2.default.black, ';& img{width:100%;margin:0;}');
	
	var TeamDescription = /*#__PURE__*/exports.TeamDescription = (0, _reactEmotion2.default)('div', {
	  target: 'css-62tymv0'
	})('width:100%;height:auto;padding:0.5rem 0.5rem;& h2{margin:0;}& p{margin-top:1rem;}& ul{margin:0;display:flex;list-style-type:none;}& ul li{margin:0;margin-left:0.5rem;}& ul li:first-child{margin:0;}');
	
	var TeamCard = exports.TeamCard = function TeamCard(_ref) {
	  var children = _ref.children;
	
	  return _react2.default.createElement(
	    'div',
	    { className: teamStyle },
	    children
	  );
	};
	
	exports.default = function (_ref2) {
	  var inverted = _ref2.inverted,
	      children = _ref2.children;
	
	  return _react2.default.createElement(
	    'div',
	    { className: inverted ? cardInverted : cardNormal },
	    children
	  );
	};

/***/ }),

/***/ 38:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.List = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEmotion = __webpack_require__(6);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var listStyle = /*#__PURE__*/(0, _reactEmotion.css)('list-style-type:none;margin:0;& h1{color:inherit;text-decoration:underline;}& a{color:black;cursor:pointer;opacity:1;transition:opacity .15s ease-in;transition:color .15s ease-in;&:hover{text-decoration:none;box-shadow:none;opacity:.5;transition:opacity .15s ease-in;}}');
	
	var List = exports.List = function List(_ref) {
	  var children = _ref.children;
	
	  return _react2.default.createElement(
	    'ul',
	    { className: listStyle },
	    children
	  );
	};

/***/ }),

/***/ 175:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Hero = __webpack_require__(12);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _Lists = __webpack_require__(38);
	
	var _Lists2 = _interopRequireDefault(_Lists);
	
	var _teamHeaderBig = __webpack_require__(112);
	
	var _teamHeaderBig2 = _interopRequireDefault(_teamHeaderBig);
	
	var _teamHeaderSmall = __webpack_require__(113);
	
	var _teamHeaderSmall2 = _interopRequireDefault(_teamHeaderSmall);
	
	var _Layout = __webpack_require__(7);
	
	var _Cards = __webpack_require__(37);
	
	var _Cards2 = _interopRequireDefault(_Cards);
	
	var _feather = __webpack_require__(39);
	
	var _feather2 = _interopRequireDefault(_feather);
	
	var _colors = __webpack_require__(3);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _SEO = __webpack_require__(26);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var data = _ref.data;
	
	  var location = data.allBusinessJson.edges[0].node.locations;
	  var myTitle = 'Structured Cabling, Data Networks, Low Voltage Nationwide | PCS';
	  var myDesc = 'Preferred Cabling Systems installs and designs data networks for the biggest hospitality brands across the US. PCS is a nationwide low voltage contractor.';
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(_SEO2.default, { title: myTitle,
	      description: myDesc
	    }),
	    _react2.default.createElement(
	      _Hero2.default,
	      { imageBig: _teamHeaderBig2.default, imageSmall: _teamHeaderSmall2.default },
	      _react2.default.createElement(
	        _Layout.Box,
	        { color: "white", p: [3, 3, 4], align: "left" },
	        _react2.default.createElement(
	          "h1",
	          null,
	          "Data Experts With Offices in Tennessee, Georgia, and Florida"
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Layout.Box,
	      { color: _colors2.default.black,
	        py: "1rem",
	        pl: ["1em", "2em", "3em", "10em"],
	        pr: ["1em", "2em", "3em", "10em"],
	        align: "center" },
	      _react2.default.createElement(
	        "p",
	        null,
	        " Come visit us at our office.Call to schedule an appointment ",
	        _react2.default.createElement(
	          "a",
	          { href: "tel:877-307-8131" },
	          " 877 & #8211;307 & #8211;8131 "
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Layout.Box,
	      { color: "red", p: [2, 3, 2], align: "center" },
	      _react2.default.createElement(
	        _Layout.Flex,
	        { wrap: ["wrap", "wrap", "wrap"], justify: "space-between" },
	        location.map(function (item) {
	          return _react2.default.createElement(
	            _Layout.Box,
	            { key: item.id, color: "red", width: [1, 1, 1 / 3.3] },
	            _react2.default.createElement(
	              _Cards2.default,
	              null,
	              _react2.default.createElement(
	                "h3",
	                { key: item.id },
	                item.city,
	                " Office "
	              ),
	              _react2.default.createElement(
	                "h5",
	                null,
	                item.street
	              ),
	              _react2.default.createElement(
	                "h5",
	                null,
	                item.city,
	                ", ",
	                item.state,
	                " ",
	                item.zip
	              )
	            )
	          );
	        })
	      )
	    )
	  );
	};
	
	var query = exports.query = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-locations-js-d5894885d0b00f13bf28.js